var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-140.7 0-256 115.3-256 256s115.3 256 256 256 256-115.3 256-256-115.3-256-256-256z",
    fill: "#f3f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 140.7-115.3 256-256 256v-512c140.7 0 256 115.3 256 256z",
    fill: "#e1e6f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ff7f40",
    r: 226
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482 256c0 124.2-101.8 226-226 226v-452c124.2 0 226 101.8 226 226z",
    fill: "#f25a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.633 256 53.042-53.042c5.856-5.856 5.859-15.352 0-21.211l-42.437-42.422c-5.859-5.859-15.352-5.859-21.211 0l-53.027 53.042-53.042-53.042c-5.859-5.859-15.352-5.859-21.211 0l-42.422 42.422c-5.859 5.859-5.859 15.352 0 21.211l53.042 53.042-53.042 53.027c-5.859 5.859-5.859 15.352 0 21.211l42.422 42.437c5.856 5.856 15.35 5.861 21.211 0l53.042-53.042 53.027 53.042c5.856 5.856 15.35 5.861 21.211 0l42.437-42.437c5.856-5.856 5.859-15.352 0-21.211z",
    fill: "#f3f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.238 372.675 42.437-42.437c5.856-5.856 5.859-15.352 0-21.211l-53.042-53.027 53.042-53.042c5.856-5.856 5.859-15.352 0-21.211l-42.437-42.422c-5.859-5.859-15.352-5.859-21.211 0l-53.027 53.042v127.266l53.027 53.042c5.856 5.856 15.35 5.861 21.211 0z",
    fill: "#e1e6f0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.ff504e5d6be511c2022288d341c87462.svg";
export { ForwardRef as ReactComponent };